<app-spinner *ngIf="loadingPickupPlaces"></app-spinner>

<div *ngIf="pickupPlaces && meta.totalItems > 0">
  <form [formGroup]="form" novalidate>
    <div class="form-group">
      <div class="row">
        <div class="col-md-3">
          <!-- <label>{{ 'SEARCH' | translate }}</label> -->
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-search" title="{{ 'NAME' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_name'"
              [value]="filterCriteria.by_name"
              [pattern]="'text'"
              [placeHolder]="'NAME'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>
        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-tag" title="{{ 'TYPE' | translate }}"></i>
            </span>
            <mat-select
              (selectionChange)="filterPickupPlaces('by_type', $event.value)"
              formControlName="by_type"
            >
              <!-- placeholder="{{ 'ALL' | translate }}" -->
              <mat-option value="">{{ 'ALL' | translate }}</mat-option>
              <mat-option *ngFor="let option of pickupPlaceOptions" [value]="option.type">
                {{ option.name | translate }}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-map-marker" title="{{ 'LOCATION' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_location'"
              [value]="filterCriteria.by_location"
              [pattern]="'text'"
              [placeHolder]="'LOCATION'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>

        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="fa fa-map" title="{{ 'ZONE' | translate }}"></i>
            </span>
            <app-search-text-input
              [field]="'by_zone'"
              [value]="filterCriteria.by_zone"
              [pattern]="'text'"
              [placeHolder]="'ZONE'"
              (searched)="onSearched($event)"
            >
            </app-search-text-input>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="meta.itemsFound > 0">
    <table class="table table-striped table-hover table-highlight-head table-vertical-align">
      <thead>
        <tr>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'name'"
              (sorted)="onSorted($event)"
            >
              {{ 'NAME' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'type'"
              (sorted)="onSorted($event)"
            >
              {{ 'TYPE' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'zone'"
              (sorted)="onSorted($event)"
            >
              {{ 'ZONE' | translate }}
            </app-sort-by>
          </th>
          <th>
            <app-sort-by
              [sortDir]="filterCriteria.sortDir"
              [sortBy]="filterCriteria.sortedBy"
              [sortValue]="'location'"
              (sorted)="onSorted($event)"
            >
              {{ 'LOCATION' | translate }}
            </app-sort-by>
          </th>
          <th style="width: 60px" class="align-center">
            <a
              (click)="reloadPickupPlaces()"
              title="{{ 'REFRESH' | translate }}"
              class="btn btn-xs btn-transparent"
            >
              <i class="fa fa-refresh"></i>
            </a>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let pickupPlace of pickupPlaces" id="{{ pickupPlace.id }}">
          <!-- Name -->
          <td
            (click)="selectPickupPlace(pickupPlace)"
            [ngClass]="utilService.checkItemStatus(pickupPlace.status)"
            class="cursor"
          >
            {{ pickupPlace.name }}
          </td>

          <!-- Type -->
          <td
            (click)="selectPickupPlace(pickupPlace)"
            [ngClass]="utilService.checkItemStatus(pickupPlace.status)"
            class="cursor"
          >
            {{ pickupPlace.type | uppercase | translate }}
          </td>

          <!-- Location -->
          <td
            (click)="selectPickupPlace(pickupPlace)"
            [ngClass]="utilService.checkItemStatus(pickupPlace.status)"
            class="cursor"
          >
            {{ pickupPlace.location.name }}
          </td>

          <!-- Zone -->
          <td
            (click)="selectPickupPlace(pickupPlace)"
            [ngClass]="utilService.checkItemStatus(pickupPlace.status)"
            class="cursor"
          >
            {{ pickupPlace.zone.name }}
          </td>

          <td class="align-center">
            <div class="btn-group">
              <span class="dropdown-toggle btn btn-xs btn-transparent" data-toggle="dropdown">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </span>
              <ul class="dropdown-menu pull-right">
                <li *ngIf="permissions.canShow">
                  <a class="cursor" (click)="selectPickupPlace(pickupPlace, 'edit')">
                    <i class="fa fa-pencil"></i> {{ 'EDIT' | translate }}
                  </a>
                </li>
                <li *ngIf="permissions.canUpdate">
                  <a class="cursor" (click)="changePickupPlaceStatus(pickupPlace)">
                    <i
                      [ngClass]="
                        pickupPlace.status === 'active'
                          ? 'fa fa-minus-square'
                          : 'fa fa-check-square'
                      "
                    ></i>
                    {{
                      pickupPlace.status === 'active'
                        ? ('DEACTIVATE' | translate)
                        : ('ACTIVATE' | translate)
                    }}
                  </a>
                </li>
                <li *ngIf="permissions.canDestroy" class="divider"></li>
                <li *ngIf="permissions.canDestroy">
                  <a class="cursor" (click)="deletePickupPlace(pickupPlace)">
                    <i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <app-table-footer
      [meta]="meta"
      (selectedPage)="onSelectedPage($event)"
      *ngIf="meta.totalPages > 1"
    ></app-table-footer>
  </div>

  <div *ngIf="meta.itemsFound === 0" class="alert alert-warning align-center" style="padding: 40px">
    <i class="fa fa-ban fa-4x"></i>
    <h3>{{ 'NO_ITEMS_FOUND' | translate }}</h3>

    <a (click)="clearSearchForm()" class="cursor">
      <i class="fa fa-times"></i> {{ 'CLEAR_SEARCH' | translate }}
    </a>
  </div>
</div>

<div
  *ngIf="pickupPlaces && meta.totalItems === 0"
  class="alert alert-info align-center"
  style="padding: 40px"
>
  <i class="fa fa-ban fa-4x"></i>
  <h5>{{ 'NO_ITEMS_FOUND' | translate }}</h5>
</div>
